import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FullscreenModalHeaderGroup({
  position,
  isMobileHeader,
  children
}) {
  return /*#__PURE__*/_jsx(Flex, {
    paddingBlockStart: isMobileHeader ? '400' : undefined,
    flexDirection: position === 'center' ? 'column' : 'row',
    alignItems: "center",
    flexBasis: position === 'center' ? 'auto' : 0,
    flexGrow: position === 'center' ? 0 : 1,
    flexShrink: position === 'center' ? 1 : 0,
    justifyContent: position === 'right' ? 'end' : undefined,
    children: children
  });
}